<template>
  <Layout style="background: #21343b">
    <h2 slot="title" class="big text-center" style="color: white" v-if="!isChkLoading">
      {{ $t('signUp') }}
    </h2>
    <v-form
      slot="content"
      ref="signUpForm"
      class="sign text-center mt-4"
      @submit.prevent="setSignUp"
      lazy-validation
      v-if="!isChkLoading"
    >
      <v-row v-if="userInfo && userInfo.userStatus == 'G'" align="center" justify="center">
        <v-col cols="12" class="" align-self="center" align="center">
          <v-avatar
            :color="userInfo.userDisplayName || userInfo.userFullName | iconBackground"
            class="logo"
            round
            size="80"
            style="cursor: pointer"
          >
            <span
              v-if="!userInfo.userPicture"
              style="color: #ffffff; font-size: 25px; text-align: center; font-weight: bold"
            >
              {{ userInfo.userDisplayName || userInfo.userFullName | iconFilter }}
            </span>
            <v-img :src="userInfo.userPicture" v-else />
          </v-avatar>
        </v-col>
        <v-col cols="12" class="mb-10" align-self="center" align="center">
          <span style="color: #eee; font-size: 18px">{{ 'As ' }}{{ userInfo.userDisplayName }}</span>
        </v-col>
      </v-row>
      <v-btn
        v-if="verifiedState !== State.Verified"
        dark
        block
        outlined
        elevation="0"
        height="40"
        id="signUpWithGoogle"
        class="google"
        @click="setSignUpWithGoogle"
      >
        <span class="icon mr-4" />
        {{ $t('signUpWithGoogle') }}
      </v-btn>
      <v-divider class="mt-6 mb-4" color="#96A7AF" />
      <v-container class="pl-0 pr-0">
        <v-row>
          <v-col class="pt-0 pb-0 text-left">
            <label for="email" class="text-left" style="color: white">{{ $t('email') }}</label>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-text-field
              outlined
              dense
              dark
              :disabled="verifiedState === State.Verified"
              ref="email"
              id="email"
              :placeholder="$t('msgEnterEmail')"
              hide-details="auto"
              :rules="[rules.required(email, 'email'), rules.email]"
              v-model="email"
              @keyup="checkVal(0, $refs.email.hasError)"
              @blur="checkVal(0, $refs.email.hasError)"
              :autofocus="email ? true : false"
            />
          </v-col>
        </v-row>
        <v-row justify="center" align="center" v-if="verifiedState === State.InProgress">
          <v-col class="pt-0 pb-0 mt-5">
            <p class="text-center" style="color: #27cd8b">
              {{ $t('msgSendVerifyCodeInfo') }}
            </p>
          </v-col>
        </v-row>
        <v-row v-if="verifiedState === State.InProgress">
          <v-col class="pt-0 pb-0 mt-5 text-left">
            <label for="verifyCode" class="text-left" style="color: white">
              {{ $t('verifyCode') }}
            </label>
          </v-col>
        </v-row>
        <v-row v-if="verifiedState === State.InProgress">
          <v-col class="pt-0 pb-0">
            <v-text-field
              outlined
              dense
              dark
              ref="verifyCode"
              id="verifyCode"
              :placeholder="$t('msgEnterVerifyCode')"
              :maxlength="6"
              hide-details="auto"
              :rules="[rules.verifyCode(verifyCode, 'verifyCode')]"
              validate-on-blur
              v-model="verifyCode"
              @keyup="isVerifyAble = !$refs.verifyCode.hasError"
              @blur="isVerifyAble = !$refs.verifyCode.hasError"
            />
          </v-col>
        </v-row>
        <v-row v-if="verifiedState === State.Verified">
          <v-col class="pt-0 pb-0 mt-5 text-left">
            <label for="userFullName" class="text-left" style="color: white">
              {{ $t('userFullName') }}
            </label>
          </v-col>
        </v-row>
        <v-row v-if="verifiedState === State.Verified">
          <v-col class="pt-0 pb-0">
            <v-text-field
              outlined
              dense
              dark
              ref="userFullName"
              id="userFullName"
              :placeholder="$t('msgEnterUserFullName')"
              hide-details="auto"
              :rules="[rules.required(userFullName, 'userFullName')]"
              validate-on-blur
              v-model="userFullName"
              @keyup="checkVal(1, $refs.userFullName.hasError)"
              @blur="checkVal(1, $refs.userFullName.hasError)"
            />
          </v-col>
        </v-row>
        <v-row v-if="verifiedState === State.Verified">
          <v-col class="pt-0 pb-0 mt-5 text-left">
            <label for="userDisplayName" class="text-left" style="color: white">
              {{ $t('userDisplayName') }}
              <span class="optional">({{ $t('optional') }})</span>
            </label>
          </v-col>
        </v-row>
        <v-row v-if="verifiedState === State.Verified">
          <v-col class="pt-0 pb-0">
            <v-text-field
              outlined
              dense
              dark
              ref="userDisplayName"
              id="userDisplayName"
              :placeholder="$t('msgEnterUserDisplayName')"
              hide-details="auto"
              :rules="userDisplayName ? [rules.required(userDisplayName, 'userDisplayName')] : []"
              validate-on-blur
              v-model="userDisplayName"
              @keyup="userDisplayName ? checkVal(2, $refs.userDisplayName.hasError) : true"
              @blur="userDisplayName ? checkVal(2, $refs.userDisplayName.hasError) : true"
            />
          </v-col>
        </v-row>
        <v-row v-if="verifiedState === State.Verified">
          <v-col class="pt-0 pb-0 mt-5 text-left">
            <label for="password" class="text-left" style="color: white">{{ $t('password') }}</label>
          </v-col>
        </v-row>
        <v-row v-if="verifiedState === State.Verified">
          <v-col class="pt-0 pb-0">
            <v-text-field
              type="password"
              outlined
              dense
              dark
              ref="password"
              id="password"
              :placeholder="$t('msgEnterPassword')"
              hide-details="auto"
              :rules="[rules.required(password, 'password'), rules.min(password)]"
              v-model="password"
              @keyup="checkVal(3, $refs.password.hasError)"
              @blur="checkVal(3, $refs.password.hasError)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0 mt-5">
            <v-btn
              v-if="verifiedState === State.NotVerified"
              block
              dark
              elevation="0"
              height="40"
              :disabled="!checkEmailAble || isSendCodeLoading"
              :loading="isSendCodeLoading"
              :class="'btn-' + (checkEmailAble ? 'able' : 'disable')"
              id="sendVerifyCode"
              @click="setVerifyCode"
            >
              {{ $t('continueWithEmail') }}
            </v-btn>

            <v-btn
              v-else-if="verifiedState === State.InProgress"
              block
              dark
              elevation="0"
              height="40"
              :disabled="!isVerifyAble || isCheckVerifyLoading"
              :loading="isCheckVerifyLoading"
              :class="'btn-' + (isVerifyAble ? 'able' : 'disable')"
              id="checkVerifyCode"
              @click="checkVerify"
            >
              {{ $t('createNewAccount') }}
            </v-btn>

            <!-- 이메일 인증 후 가입버튼 -->
            <v-btn
              v-else-if="verifiedState === State.Verified"
              type="submit"
              block
              dark
              elevation="0"
              height="40"
              :disabled="!isBtnAble || isLoading"
              :loading="isLoading"
              :class="'btn-' + (isBtnAble ? 'able' : 'disable')"
              id="continueWithEmail"
              @click="setSignUpWithEmail"
            >
              {{ $t('continueWithEmail') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="verifiedState !== State.Verified">
          <v-col class="pt-0 pb-0 mt-5">
            <v-alert dense style="background-color: transparent; color: #96a7af; font-size: 12px; padding: 0">
              <span v-html="this.$t('policyText')" />
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="showMsg">
          <v-col class="pt-0 pb-0 mt-5">
            <v-alert dense outlined dark>
              <span v-html="errorMessage" />
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <loading-dialog :isLoading="isLoading"></loading-dialog>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Onboarding'
import { fill } from 'lodash'
import { isNull, regExpTest } from '@/common/lib/strLib'
import firebase from 'firebase/app'
import { setUserFunnel, setVerifyCode, checkVerify } from '@/services/api'
import { mapState } from 'vuex'
import Toast from '@/views/meeting/component/Toast'

/**
 * Email 인증 상태
 */
const State = Object.freeze({
  NotVerified: 'notVerified',
  InProgress: 'inProgress',
  Verified: 'verified',
})

export default {
  name: 'SignUp',
  components: {
    Layout,
  },
  props: ['passedEmail'],
  data: () => ({
    email: '',
    password: '',
    userFullName: '',
    userDisplayName: '',
    valChkArray: [],
    isBtnAble: false,
    isVerifyAble: false,
    isLoading: false,
    isSendCodeLoading: false,
    isCheckVerifyLoading: false,
    showMsg: false,
    errorCode: '',
    errorMessage: '',
    policy: '',
    chkMtPublic: false,
    State,
    verifyCode: '',
    verifiedState: State.NotVerified,
  }),
  async created() {
    let currentUser = await firebase.auth().currentUser
    if (currentUser !== null && this.userInfo && this.userInfo.userStatus !== 'G') {
      await this.$store.dispatch('setIsLoading', true)
    } else if (currentUser !== null && this.isLinkWithSignin) {
      let name = this.userInfo.userDisplayName || this.userInfo.userFullName
      this.userFullName = name
      this.userDisplayName = name
    }
    this.chkMtPublic = this.$store.getters.chkMtPublic
    this.valChkArray = fill(Array(4), false)

    let storedEmail

    try {
      storedEmail = localStorage.getItem('passedEmail')
    } catch (e) {
      console.log(e)
    }

    if (this.passedEmail || (storedEmail && storedEmail !== null)) {
      this.email = this.passedEmail || storedEmail
    }

    this.$analytics.logEvent('screen_view', {
      firebase_screen: '회원가입',
      firebase_screen_class: 'SignUp',
    })
  },
  computed: {
    rules() {
      let vm = this

      // TODO: 사용할 수 없는 이름 (Full Name / Display Name) 체크?
      return {
        required: (value, type) => !isNull(value) || vm.$t('msgEnter' + type.charAt(0).toUpperCase() + type.slice(1)),
        min: (value) => value.length >= 8 || vm.$t('msgPasswordMinLength'),
        email: (value) => regExpTest('EMAIL', value) || vm.$t('msgCheckEmailFormat'),
        verifyCode: (value) => value.length === 6 || vm.$t('msgVerifyCodeMinLength'),
      }
    },
    checkEmailAble() {
      return this.valChkArray && this.valChkArray !== null && this.valChkArray.length > 0 ? this.valChkArray[0] : false
    },
    isLinkWithSignin() {
      return this.userInfo && this.userInfo.userStatus === 'G'
    },
    ...mapState({
      userInfo: (state) => {
        return state.auth.userInfo
      },
      isChkLoading: (state) => {
        return state.loading.isLoading
      },
    }),
  },
  methods: {
    checkVal(index, result) {
      this.valChkArray.splice(index, 1, !result)
      if (!this.userDisplayName) this.valChkArray[2] = true
      this.isBtnAble = !this.valChkArray.includes(false)

      if (this.userFullName) this.valChkArray[1] = true
      if (this.userDisplayName) this.valChkArray[2] = true
    },
    // Email 인증코드 전송
    async setVerifyCode() {
      this.isSendCodeLoading = true
      try {
        this.verifiedState =
          (await setVerifyCode(this, this.email, 'signUp', this.isLinkWithSignin)) === 'success'
            ? State.InProgress
            : State.NotVerified
      } catch (error) {
        if (error.response.data === 'userExist') {
          // notify(this, 'Error', this.$t('msgEmailAlreadyInUse'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('msgEmailAlreadyInUse'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } finally {
        this.isSendCodeLoading = false
      }
    },
    // Email 인증코드 확인
    async checkVerify() {
      this.isCheckVerifyLoading = true
      try {
        this.verifiedState =
          (await checkVerify(this, this.email, 'signUp', this.verifyCode)) === 'success'
            ? State.Verified
            : State.InProgress
      } catch (error) {
        if (error.response.data === 'incorrectCode') {
          // notify(this, 'Error', this.$t('msgIncorrectCode'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('msgIncorrectCode'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } finally {
        this.isCheckVerifyLoading = false
      }
    },
    async setSignUpWithGoogle() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      try {
        let result
        let provider = new firebase.auth.GoogleAuthProvider()
        // 게스트 로그인시 Google 로그인 계정과 게스트 계정을 연동해준다.
        if (this.isLinkWithSignin) {
          await firebase.auth().currentUser.getIdToken(true)
          result = await firebase.auth().currentUser.linkWithPopup(provider)

          await result.user.updateProfile({
            displayName: this.userDisplayName ? this.userDisplayName : this.userFullName,
          })
        } else {
          result = await firebase.auth().signInWithPopup(provider)
        }

        this.moveRouter(result, true)
      } catch (error) {
        this.errorCode = error.code
        this.errorMessage =
          this.errorCode === 'auth/user-not-found' || this.errorCode === 'auth/wrong-password'
            ? this.$t('msgSignInFailed')
            : error.message
        this.showMsg = true
      } finally {
        this.isLoading = false
      }
    },
    async setSignUpWithEmail() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      if (!this.$refs.signUpForm.validate()) return false

      try {
        let result

        // 게스트 로그인시 UserEmail 을 연동해준다.
        if (this.isLinkWithSignin) {
          await firebase.auth().currentUser.getIdToken(true)
          let emailCredential = firebase.auth.EmailAuthProvider.credential(this.email, this.password)
          result = await firebase.auth().currentUser.linkWithCredential(emailCredential)
        }
        // 일반 이메일 회원가입
        else {
          result = await firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
        }
        await result.user.updateProfile({
          displayName: this.userDisplayName ? this.userDisplayName : this.userFullName,
        })
        this.moveRouter(result, false)
        // 이메일 인증 메일 발송 ( 자체 인증 구현으로 제거 )
        // await result.user.sendEmailVerification()
      } catch (error) {
        this.errorCode = error.code
        this.errorMessage =
          this.errorCode === 'auth/email-already-in-use' ? this.$t('msgEmailAlreadyInUse') : error.message
        this.showMsg = true
      } finally {
        this.isLoading = false
      }
    },
    async moveRouter(userResult, isGoogleSignup) {
      this.$store.dispatch('setIsLoading', true)
      try {
        // 현재 유저 설정
        await this.$store.dispatch('setCurrentUser', userResult.user)
        // api header Authorization 설정
        await this.$store.dispatch('setApiHeader')
        // Google Login Routing 처리
        if (isGoogleSignup) {
          // 소셜 로그인 최초 로그인
          if (userResult.user !== null && userResult.additionalUserInfo.isNewUser) {
            // 최초 로그인이면 가입
            await this.$store.dispatch('setSignUp', {
              userFullName: '',
              userDisplayName: userResult.user.displayName,
              deviceToken: '',
            })
            this.$analytics.logEvent('signup_with_google', {
              name: 'signup_with_google',
              methodType: this.chkMtPublic ? 'share_link' : 'normal',
              userStatus: 'C',
            })
          } else {
            await this.$store.dispatch('setSignIn', {
              deviceToken: '',
              isLinkWithSignin: this.isLinkWithSignin,
            })
            this.$analytics.logEvent('signin_with_google', {
              name: 'signin_with_google',
              methodType: this.chkMtPublic ? 'share_link' : 'normal',
              userStatus: 'C',
            })
          }
        }
        // Email Login Routing 처리
        else {
          if (this.isLinkWithSignin) {
            await this.$store.dispatch('setSignIn', {
              deviceToken: '',
              isLinkWithSignin: this.isLinkWithSignin,
            })
          } else {
            await this.$store.dispatch('setSignUp', {
              userFullName: this.userFullName,
              userDisplayName: this.userDisplayName,
              deviceToken: '',
            })
          }

          this.$analytics.logEvent('signup_with_email', {
            name: 'signup_with_email',
            methodType: this.chkMtPublic ? 'share_link' : 'normal',
            userStatus: 'C',
          })
        }

        if (this.userInfo && this.userInfo !== null) {
          await this.checkFunnel(isGoogleSignup ? 'signup_with_google' : 'signup_with_email')

          // 참여 워크스페이스가 없으면, 워크스페이스 생성/참여 페이지로 이동
          await this.$store.dispatch('getUserWsList')

          // if (location.pathname.includes('share')) {
          if (this.$store.getters.signInRedirectUrl && this.$store.getters.signInRedirectUrl !== null) {
            let signInRedirectUrl = this.$store.getters.signInRedirectUrl
            await this.$store.dispatch('setSignInRedirectUrl', null)
            this.$router.push(signInRedirectUrl).catch(() => {})
          } else {
            if (this.$store.getters.userWsList.length === 0) this.$router.replace({ name: 'Workspace' }).catch(() => {})
            else {
              this.$router.replace(`${this.$store.getters.userWsList[0].wsDomain}/my`).catch(() => {})
            }
          }
        }
      } catch (error) {
        this.$store.dispatch('setIsLoading', false)
      }
    },
    async checkFunnel(signupType) {
      try {
        const funnel = this.userInfo.funnel
        if (!funnel || funnel === '') {
          let result = await setUserFunnel(this, 'evaluator')
          this.$store.commit('setUserInfo', result)

          this.$analytics.logEvent('funnel_evaluator', {
            uid: this.userInfo.userId,
            createdAt: Date.now(),
            methodType: signupType,
          })
        }
      } catch (e) {
        console.log()
      }
    },
  },
}
</script>
